<template>
  <div class="scheduleRules" v-loading="loading" :element-loading-text="loadingType === 1 ? '规则应用中，请耐心等待' : ''" element-loading-spinner="el-icon-loading">
    <div class="header">
      <div class="header_left">
        <div class="header_btn">
          <span class="el-icon-arrow-left header_btn_icon"></span>
          <span class="header_btn_text" @click="toBack">返回</span>
        </div>
        <div class="header_label">{{ doctorName }}的周排班</div>
        <div class="header_tips">请在周排班中添加医生固定的班次，应用规则后系统将按此排班规则从生效期开始重复生成排班！</div>
      </div>
      <div class="header_right">
        <el-button v-if="hasRules" plain @click="scheduleClear">清除排班规则</el-button>
      </div>
    </div>
    <div class="schedule_tips">本月应坐诊{{visitCount.shouldVisitCount || ''}}次（根据当前排班计算）</div>

    <div class="schedule">
      <table class="schedule_table">
        <thead>
          <tr class="table_thead_tr">
            <th v-for="week in weekList" :key="week.value" class="table_thead_th">{{ week.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr class="table_tbody_tr">
            <td v-for="week in weekList" :key="week.value" class="table_tbody_td">
              <div class="table_item">
                <div class="table_item_schedule">
                  <ScheduleRulesCard
                    v-for="schedule in scheduleRulesMap[week.value]"
                    :key="schedule.vId"
                    v-show="schedule.delFlag === '0'"
                    class="schedule_rules_card"
                    :week="week.value"
                    :info="schedule"
                    @scheduleEdit="scheduleEdit"
                    @scheduleDelete="scheduleDelete">
                  </ScheduleRulesCard>
                </div>
              </div>
              <div class="table_item_footer">
                <div class="table_item_footer_info">
                  <div class="table_item_footer_btn" @click="scheduleEdit({ type: 'add', week: week.value, ruleType: '1' })">
                    <span class="el-icon-plus table_item_footer_btn_icon"></span>
                    <span class="table_item_footer_btn_text">门诊排班</span>
                  </div>
                  <div class="table_item_footer_btn" @click="scheduleEdit({ type: 'add', week: week.value, ruleType: '2' })">
                    <span class="el-icon-plus table_item_footer_btn_icon"></span>
                    <span class="table_item_footer_btn_text">理疗执行</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="takeEffect">
      <el-form ref="form" :model="takeEffectMap.form" :rules="takeEffectMap.rules">
        <el-form-item prop="date">
          <div class="takeEffect_label">
            <span class="takeEffect_label_require">*</span>
            <span class="takeEffect_label_text">生效日期</span>
          </div>
          <el-date-picker
            class="takeEffect_date"
            v-model="takeEffectMap.form.date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            :picker-options="takeEffectMap.pickerOptions">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="operate">
      <div class="operate_submit" @click="rulesSubmit">应用规则</div>
    </div>
    <ScheduleEditDefault ref="scheduleEditDefault" application="rules" @submit="editSubmit"></ScheduleEditDefault>
    <ScheduleEditPhysio ref="scheduleEditPhysio" application="rules" @submit="editSubmit"></ScheduleEditPhysio>
    <ScheduleRulesClear ref="scheduleRulesClear" @submit="rulesClearSubmit"></ScheduleRulesClear>
    <ScheduleRulesPrompt ref="scheduleRulesPrompt" @submit="rulesPromptSubmit"></ScheduleRulesPrompt>
  </div>
</template>

<script>
  import ScheduleRulesCard from './components/scheduleRulesCard.vue'
  import ScheduleEditDefault from './components/scheduleEdit_default.vue'
  import ScheduleEditPhysio from './components/scheduleEdit_physio.vue'
  import ScheduleRulesClear from './components/scheduleRulesClear.vue'
  import ScheduleRulesPrompt from './components/scheduleRulesPrompt.vue'

  import { getScheduleRule, setScheduleRule, deleteScheduleRule,getDoctorMonthAllotBedNumber } from '@/api/schedule'
  export default {
    name: 'ScheduleRules',
    components: {
      ScheduleRulesCard,
      ScheduleEditDefault,
      ScheduleEditPhysio,
      ScheduleRulesClear,
      ScheduleRulesPrompt
    },
    data() {
      return {
        loadingType: 0, // 0: 默认, 1: 规则应用
        loading: false,
        hasRules: false,
        deptId: '',
        deptName: '',
        doctorId: '',
        doctorName: '',
        weekList: [
          { label: '周一', value: 'monday' },
          { label: '周二', value: 'tuesday' },
          { label: '周三', value: 'wednesday' },
          { label: '周四', value: 'thursday' },
          { label: '周五', value: 'friday' },
          { label: '周六', value: 'saturday' },
          { label: '周日', value: 'sunday' }
        ],
        scheduleRulesMap: {
          monday: [],
          tuesday: [],
          wednesday: [],
          thursday: [],
          friday: [],
          saturday: [],
          sunday: []
        },
        takeEffectMap: {
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() < Date.now() - (24 * 60 * 60 * 1000) || time.getTime() > Date.now() + (59 * 24 * 60 * 60 * 1000);
            }
          },
          rules: {
            date: [{ required: true, message: '请选择日期', trigger: 'change' }]
          },
          form: {
            date: ''
          }
        },
        visitCount:{}
      }
    },
    created() {
      const deptInfo = sessionStorage.getItem('deptInfo') && JSON.parse(sessionStorage.getItem('deptInfo'))
      this.deptId = deptInfo.deptId || ''
      this.deptName = deptInfo.deptName || ''

      this.doctorId = this.$route.params.id || ''
      this.doctorName = this.$route.query.doctorName || ''

      this.getScheduleRule()
      this.getDoctorMonthAllotBedNumber()
    },
    methods: {
      generateUUID () {
        return 'xxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      },
      toBack () {
        this.$router.back()
      },
      async getScheduleRule () {
        this.loadingType = 0
        this.loading = true
        const res = await getScheduleRule({ doctorId: this.doctorId })
        this.loading = false
        if (res.code === 200) {
          Object.keys(res.data).forEach(key => {
            this.scheduleRulesMap[key] = res.data[key].map(v => {
              return {
                ...v,
                vId:this.generateUUID()
              }
            })
          })
          const hasRules = Object.keys(this.scheduleRulesMap).some(key => this.scheduleRulesMap[key].length > 0)
          this.hasRules = hasRules
        }
      },
      scheduleEdit (info) {
        if (info.ruleType === '1') {
          this.$refs.scheduleEditDefault.init(info)
        } else {
          this.$refs.scheduleEditPhysio.init({
            ...info,
            doctorId: this.doctorId
          })
        }
      },
      scheduleDelete(info) {
        this.$confirm('确认删除该排班规则?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          customClass: 'scheduleRules_confirm',
          closeOnClickModal: false,
          closeOnPressEscape: false
        }).then(() => {
          const index = this.scheduleRulesMap[info.week].findIndex(v => v.vId === info.vId)
          if (['', null, undefined].includes(info.id)) {
            this.scheduleRulesMap[info.week].splice(index, 1)
          } else {
            this.scheduleRulesMap[info.week][index].delFlag = '1'
          }
        }).catch(() => {})
      },
      editSubmit (info) {
        let list = []

        if (info.type === 'add') {
          info.weeks && info.weeks.forEach(week => {
            list.push({
              originWeek: info.originWeek,
              week: week,
              vId: this.generateUUID(),
              id: info.id,
              dept: { deptId: this.deptId, deptName: this.deptName },
              doctor: { doctorId: this.doctorId, doctorName: this.doctorName },
              clinic: { clinicId: info.clinicId, clinicName: info.clinicName },
              ruleTime: { 
                timeType: info.timeType,
                appointmentStartTime: `${info.appointmentStartTime}:00`,
                appointmentEndTime: `${info.appointmentEndTime}:00`,
                timeQuantumCode: info.timeQuantumCode,
                releaseDay: info.releaseDay,
                releasePointTime: `${info.releasePointTime}:00`
              },
              generalVo: info.generalVo,
              physicalVo: info.physicalVo,
              contributingVo: info.contributingVo,
              freeVo: info.freeVo,
              transferVo: info.transferVo,
              ruleType: info.ruleType,
              bedIndependenceNumber: info.bedIndependenceNumber,
              delFlag: '0',
              increaseSchedulingItem:info.increaseSchedulingItem
            })
          })
        } else {
          list.push({
            originWeek: info.originWeek,
            week: info.week,
            vId: info.vId,
            id: info.id,
            dept: { deptId: this.deptId, deptName: this.deptName },
            doctor: { doctorId: this.doctorId, doctorName: this.doctorName },
            clinic: { clinicId: info.clinicId, clinicName: info.clinicName },
            ruleTime: { 
              timeType: info.timeType,
              appointmentStartTime: `${info.appointmentStartTime}:00`,
              appointmentEndTime: `${info.appointmentEndTime}:00`,
              timeQuantumCode: info.timeQuantumCode,
              releaseDay: info.releaseDay,
              releasePointTime: `${info.releasePointTime}:00`
            },
            generalVo: info.generalVo,
            physicalVo: info.physicalVo,
            contributingVo: info.contributingVo,
            freeVo: info.freeVo,
            transferVo: info.transferVo,
            ruleType: info.ruleType,
            bedIndependenceNumber: info.bedIndependenceNumber,
            delFlag: '0',
            increaseSchedulingItem:info.increaseSchedulingItem
          })
        }

        try {
          list.forEach(item => {
            this.scheduleRulesMap[item.week].forEach(rule => {
              if (item.vId !== rule.vId && item.ruleType === rule.ruleType && rule.delFlag === '0') {
                if (item.ruleTime.appointmentStartTime < rule.ruleTime.appointmentEndTime && item.ruleTime.appointmentEndTime > rule.ruleTime.appointmentStartTime) {
                  throw {
                    ruleType: item.ruleType,
                    week: item.week
                  }
                }
              }
            })
          })
        } catch (e) {
          const week = this.weekList.find(item => item.value === e.week)
          const message = `${week.label}该时段内已有排班！`
          if (e.ruleType === '1') {
            this.$refs['scheduleEditDefault'].validateAppointment(message)
          } else {
            this.$refs['scheduleEditPhysio'].validateAppointment(message)
          }
          return false
        }

        list.forEach(item => {
          if (info.type === 'add') {
            this.scheduleRulesMap[item.week].push(item)
          } else {
            const scheduleIndex = this.scheduleRulesMap[item.originWeek].findIndex(obj => obj.vId === item.vId)
            if (item.week === item.originWeek) {
              this.scheduleRulesMap[item.originWeek].splice(scheduleIndex, 1, item)
            } else {
              this.scheduleRulesMap[item.originWeek].splice(scheduleIndex, 1)
              this.scheduleRulesMap[item.week].push(item)
            }
          }
          this.scheduleRulesMap[item.week].sort((a, b) => a.ruleTime.appointmentStartTime > b.ruleTime.appointmentStartTime ? 1 : -1)
        })
        if (info.ruleType === '1') {
          this.$refs['scheduleEditDefault'].close()
        } else {
          this.$refs['scheduleEditPhysio'].close()
        }
      },
      scheduleClear () {
        this.$refs['scheduleRulesClear'].open()
      },
      async rulesClearSubmit (form) {
        this.$refs['scheduleRulesClear'].close()
        this.loadingType = 0
        this.loading = true
        const res = await deleteScheduleRule({
          deptId: this.deptId,
          doctorId: this.doctorId,
          deleteDate: form.date
        })
        this.loading = false
        if (res.code === 200) {
          if (res.data.code === 250) {
            this.$refs['scheduleRulesPrompt'].open({
              title: '提示',
              tips: `以下排班存在挂号，系统已自动设置为停诊，请及时处理已挂号源！`,
              label: '含挂号的排班',
              list: res.data.data,
              isLeave: true
            })
            return false
          }
          this.$message.success('清除成功！')
          this.toBack()
        }
      },
      rulesSubmit () {
        this.$refs['form'].validate(async valid => {
          if (valid) {
            this.$confirm(`该排班规则将于【${this.takeEffectMap.form.date}】开始生效，生效后系统将按此规则重复生成排班！`, '确定应用此排班规则', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'scheduleRules_confirm',
              closeOnClickModal: false,
              closeOnPressEscape: false
            }).then(async () => {
              this.loadingType = 1
              this.loading = true
              const res = await setScheduleRule({
                beginDate: this.takeEffectMap.form.date,
                doctorId: this.doctorId,
                ruleMap: this.scheduleRulesMap
              })
              this.loading = false
              if (res.code === 200) {
                if (res.data.code === 250) {
                  this.$refs['scheduleRulesPrompt'].open({
                    title: '提示',
                    tips: `更新完成！${new Date(this.takeEffectMap.form.date).Format('MM月dd日')}（含）起排班已按新规则生成。<br/>以下排班存在挂号，系统已自动设置为停诊，请及时处理已挂号源！`,
                    label: '含挂号的排班',
                    list: res.data.data,
                    isLeave: true
                  })
                  return false
                }
                if (res.data.code === 500) {
                  this.$refs['scheduleRulesPrompt'].open({
                    title: '修改失败',
                    tips: '',
                    label: '异常数据',
                    list: res.data.data,
                    isLeave: false
                  })
                  return false
                }
                this.toBack()
              }
            }).catch(() => {})
          }
        })
      },
      rulesPromptSubmit (isLeave) {
        if (isLeave) {
          this.toBack()
        }
      },
      // 获取医生本月应坐诊次数
      async getDoctorMonthAllotBedNumber() {
        const res = await getDoctorMonthAllotBedNumber({ doctorId: this.doctorId,date: this.$moment().format('YYYY-MM') })
        if (res.code === 200) {
          this.visitCount = res.data
        } else {
          this.visitCount = {}
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .scheduleRules {
    box-sizing: border-box;
    padding: 24px 36px;
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .scheduleRules /deep/ .el-icon-loading {
    font-size: 32px;
  }

  .scheduleRules /deep/ .el-loading-text {
    margin: 12px 0 0 0;
    font-size: 18px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .header_left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .header_btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    height: 32px;
    background-color: #FFFFFF;
    border: 1px solid #D3D3D5;
    border-radius: 2px;
    cursor: pointer;
  }

  .header_btn_icon {
    font-size: 14px;
    color: #A4AFBA;
  }

  .header_btn_text {
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #1F2329;
  }

  .header_label {
    margin: 0 0 0 16px;
    font-weight: bold;
    font-size: 16px;
    color: #000000;
  }

  .header_tips {
    margin: 0 0 0 12px;
    font-size: 14px;
    color: #667182;
  }

  .header_right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  
  .schedule_tips {
    font-size: 13px;
    color: #eb6526;
    margin-top: 8px;
  }

  .schedule {
    margin: 24px 0 0 0;
    width: 100%;
  }

  .schedule_table {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 4px;
    table-layout: fixed;
  }

  .table_thead_tr {
    width: 100%;
    height: 36px;
    border-bottom: 1px solid #E0E0E0;
  }

  .table_thead_th {
    width: calc(100% / 7);
    line-height: 36px;
  }

  .table_thead_th+.table_thead_th {
    border-left: 1px solid #E0E0E0;
  }

  .table_tbody_tr {
    width: 100%;
  }

  .table_tbody_tr+.table_tbody_tr {
    border-top: 1px solid #E0E0E0;
  }

  .table_tbody_td {
    position: relative;
    z-index: 1;
    width: calc(100% / 7);
    background-color: #FFFFFF;
    vertical-align: top;
  }

  .table_tbody_td:hover {
    background-color: #F7F8F9;
  }

  .table_tbody_td+.table_tbody_td {
    border-left: 1px solid #E0E0E0;
  }

  .table_item {
    box-sizing: border-box;
    padding: 8px;
    width: 100%;
    min-height: 214px;
  }

  .table_item_schedule {
    width: 100%;
  }

  .schedule_rules_card+.schedule_rules_card {
    margin: 8px 0 0 0;
  }

  .table_item_footer {
    margin: 16px 0 0 0;
    width: 100%;
    height: 32px;
  }

  .table_item_footer_info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: absolute;
    z-index: 2;
    left: 0px;
    bottom: 0px;
    width: 100%;
    height: 32px;
    visibility: hidden;
  }

  .table_tbody_td:hover .table_item_footer_info {
    visibility: visible;
  }

  .table_item_footer_btn {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
    height: 100%;
    background-color: #FFFFFF;
    border-top: 1px solid #E0E0E0;
    border-left: 1px solid #E0E0E0;
    border-right: 1px solid #E0E0E0;
    cursor: pointer;
  }

  .table_item_footer_btn+.table_item_footer_btn {
    border-left: none;
  }

  .table_item_footer_btn_icon {
    font-size: 14px;
    color: #D3D3D5;
  }

  .table_item_footer_btn_text {
    margin: 0 0 0 4px;
    font-size: 14px;
    color: #667182;
  }

  .takeEffect {
    margin: 24px 0 0 0;
  }

  .takeEffect_label {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .takeEffect_label_require {
    line-height: 16px;
    font-size: 16px;
    color: #F54A45;
  }

  .takeEffect_label_text {
    line-height: 16px;
    font-size: 16px;
    color: #000000;
  }

  .takeEffect_date {
    margin: 12px 0 0 0;
  }

  .takeEffect_date /deep/ .el-input__inner {
    height: 40px;
  }

  .operate {
    margin: 32px 0 0 0;
  }

  .operate_submit {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 220px;
    height: 40px;
    font-size: 14px;
    color: #FFFFFF;
    background-color: #1890FF;
    border-radius: 4px;
    cursor: pointer;
  }
</style>

<style>
  .scheduleRules_confirm .el-message-box__btns .el-button {
    padding: 8px 12px;
    font-size: 14px;
    border-radius: 2px;
  }
</style>